import { Formik, Field, Form } from 'formik';
import MasterModal from 'components/organisms/masterModal';
import TextArea from 'components/atoms/textarea';
import * as yup from 'yup';
import { useRef } from 'react';

import type { FunctionComponent } from 'react';

type Props = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  loading?: boolean;
  onSubmit: (data: { reason: string }) => Promise<void>;
};

const schema = yup.object().shape({
  reason: yup.string().required('Required').trim(),
});

const EmailsResubscriptionModal: FunctionComponent<Props> = ({
  isOpen,
  setIsOpen,
  loading,
  onSubmit,
}) => {
  const submitRef = useRef<(() => void) | null>(null);

  const handleSubmit = async ({ reason }: { reason: string }) => {
    await onSubmit({ reason });
    setIsOpen(false);
  };

  return (
    <MasterModal
      isOpen={isOpen}
      toggle={() => setIsOpen(false)}
      title="Resubscribe to Emails"
      size="default"
      saveLabel="Send"
      isSaveLoading={loading}
      onSave={() => submitRef.current?.()}
    >
      <Formik
        validationSchema={schema}
        onSubmit={handleSubmit}
        initialValues={{ reason: '' }}
      >
        {({ errors, submitForm }) => {
          submitRef.current = submitForm;
          return (
            <Form>
              <Field
                id="reason"
                name="reason"
                type="text"
                as={TextArea}
                rows="8"
                placeholder="How the permission from the patient for re-subscribing was received?"
              />
              {errors.reason ? (
                <div className="input-error-message">{errors.reason}</div>
              ) : null}
            </Form>
          );
        }}
      </Formik>
    </MasterModal>
  );
};

export default EmailsResubscriptionModal;
